// plan-02 S05: analog noise pass — rare horizontal tear bands — bible S13B

import type { DrawPass } from '../canvas'

// probability of a tear per frame
const P_TEAR = 0.016

function simpleRand(seed: number): number {
  let s = seed
  s = (s * 1103515245 + 12345) & 0x7fffffff
  return s / 0x7fffffff
}

export function createAnalogNoise(reduced: boolean): DrawPass {
  return (ctx, w, h, t): void => {
    if (reduced) return
    // frame-seeded probability
    const seed = Math.floor(t * 30)
    const roll = simpleRand(seed)
    if (roll > P_TEAR) return

    const bandH = 2 + Math.floor(simpleRand(seed + 1) * 5)
    const y = Math.floor(simpleRand(seed + 2) * h)
    const shift = (simpleRand(seed + 3) - 0.5) * 8

    ctx.fillStyle = 'rgba(0, 90, 0, 0.18)'
    ctx.fillRect(shift, y, w, bandH)
  }
}
